export default `
-- CreateTable
CREATE TABLE "UserPreference" (
    "id" TEXT NOT NULL PRIMARY KEY,
    "user_id" TEXT NOT NULL,
    "workspace_id" TEXT,
    "key" TEXT NOT NULL,
    "value" TEXT NOT NULL,
    "created_by" TEXT NOT NULL,
    "created_at" DATETIME NOT NULL DEFAULT CURRENT_TIMESTAMP,
    "updated_at" DATETIME NOT NULL DEFAULT CURRENT_TIMESTAMP,
    CONSTRAINT "UserPreference_user_id_fkey" FOREIGN KEY ("user_id") REFERENCES "User" ("id") ON DELETE RESTRICT ON UPDATE CASCADE,
    CONSTRAINT "UserPreference_workspace_id_fkey" FOREIGN KEY ("workspace_id") REFERENCES "Workspace" ("id") ON DELETE SET NULL ON UPDATE CASCADE
);

-- CreateIndex
CREATE INDEX "UserPreference_user_id_idx" ON "UserPreference"("user_id");

-- CreateIndex
CREATE INDEX "UserPreference_workspace_id_idx" ON "UserPreference"("workspace_id");

-- CreateIndex
CREATE INDEX "UserPreference_key_idx" ON "UserPreference"("key");

-- CreateIndex
CREATE INDEX "UserPreference_created_by_idx" ON "UserPreference"("created_by");

-- CreateIndex
CREATE INDEX "UserPreference_created_at_idx" ON "UserPreference"("created_at");

-- CreateIndex
CREATE INDEX "UserPreference_updated_at_idx" ON "UserPreference"("updated_at");

-- CreateIndex
CREATE UNIQUE INDEX "UserPreference_user_id_workspace_id_key_key" ON "UserPreference"("user_id", "workspace_id", "key");
`;
